<header class="modal-header px-4 bg-white border-bottom-0">
  <h5 class="modal-title" id="modal-basic-title font-weight-bold">
    {{
      asignar
        ? "Asignar usuario depositario"
        : "Desasociar el usuario depositario"
    }}
  </h5>
  <button type="button" class="close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body">
  <div class="p-2">
    <form [formGroup]="formAsignarDepositario">
      <ng-container *ngIf="asignar === true">
        <div class="form-group">
          <ng-autocomplete
            [data]="usuariosLista"
            placeholder="Seleccione el usuario"
            [searchKeyword]="keyword"
            (selected)="selectEvent($event)"
            (inputCleared)="clearAutocomplete($event)"
            [itemTemplate]="itemTemplate"
            [notFoundTemplate]="notFoundTemplate"
          >
          </ng-autocomplete>

          <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.infoCadena"></a>
          </ng-template>

          <ng-template #notFoundTemplate let-notFound>
            <div [innerHTML]="">No encontrado</div>
          </ng-template>
        </div>
      </ng-container>
      <div class="form-group">
        <label class="small text-secondary" for="nit">{{
          asignar ? "Observación" : "Motivo"
        }}</label>
        <textarea
          id="observaciones"
          formControlName="observaciones"
          class="form-control form-control-sm"
          rows="4"
        ></textarea>
      </div>
      <footer class="text-right">
        <button
          class="btn btn-outline-primary modal-tipo-rnt-btn-inicio-outline mr-3 border-0"
          (click)="dismiss()"
        >
          Cancelar
        </button>
        <button
          class="btn btn-primary m-auto"
          [disabled]="!formAsignarDepositario.valid"
          (click)="sendForm()"
        >
          {{ asignar ? "Asignar" : "Desasociar" }}
        </button>
      </footer>
    </form>
  </div>
</section>
